import type { DiscreteScale, DiscreteScaleLevel } from "@Scales/Model";

export class ScaleTemplateViewerViewModel
{
    opened: boolean = false;

    name: string | null = null;
    description: string | null = null;
    levels: DiscreteScaleLevel[] = [];

    show(scale: DiscreteScale)
    {
        this.name = scale.Name;
        this.description = scale.Description;
        this.levels = scale.ScaleLevels;

        this.opened = true;
    }

    close()
    {
        this.opened = false;
    }
}